export const checkField = (fieldValue, defaultValue = '-') => {
  return fieldValue !== null && fieldValue > -1 ? fieldValue : defaultValue
}

export default {
  checkField
}
